// eslint-disable-next-line @typescript-eslint/no-inferrable-types
export const version: string = "dev";
